import Salesinfo from "../../../jsx/components/Dashboard/salesinfo/salesinfo";

const SalesInfoWrapper = () => {
  return <Salesinfo />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];
export default constore(SalesInfoWrapper);
